import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Order from '../../models/Order'

export interface OrderStatusesState extends PaginatedApiState {
  order?: Order[]
}

const OrderStatuses = (state: OrderStatusesState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<OrderStatusesState>('ORDER_STATUSES')(state, action)
  }
}

export default OrderStatuses
